/* eslint-disable */
import React from 'react';

import Button from 'components/atoms/Button';
import Heading from 'components/atoms/Heading';
import Text from 'components/atoms/Text';
import CustomModal from 'components/organisms/Modal';

interface ResendSMSQRCodeProps {
  isOpen: boolean;
  title?: string,
  desc?: string,
  submitText?: string,
  backText?: string,
  handleSubmit?: () => void;
  handleClose?: () => void;
  handleBack?: () => void;
  loadingSubmit?: boolean;
  status?: 'error' | 'success';
  smallTitle?: boolean;
}

const ResendSMSQRCode: React.FC<ResendSMSQRCodeProps> = ({
  isOpen,
  title,
  desc,
  submitText,
  backText,
  handleSubmit,
  handleBack,
  handleClose,
  loadingSubmit,
  status,
  smallTitle,
}) => (
  <div className="t-resendSMSQRCode">
    <CustomModal
      showIconClose
      isOpen={isOpen}
      modifiers={['width-420']}
      variant="transparent"
    >
      {
        title && (
          <Heading modifiers={['center', smallTitle ? '20x30' : '32x42', '700', 'smokyBlack']} content={title} />
        )
      }
      {
        desc && (
          <div className="t-notifyModal_desc">
            <Text modifiers={['20x24', '500', 'center', status === 'error' ? 'redOrange' : 'smokyBlack']} content={desc} />
          </div>
        )
      }
      <div className="t-notifyModal_button">
        {
          backText && (
            <div className="t-notifyModal_button-back" onClick={handleBack}>
              <Button modifiers={['secondary', 'lg']}>
                <Text modifiers={['gunmetal', '16x24', '600']} content={backText} />
              </Button>
            </div>
          )
        }
        {
          submitText && !status && (
            <div className="t-resendSMSQRCode_buttons">
              <div className="t-resendSMSQRCode_button-back" onClick={handleClose}>
                <Button modifiers={['outlineGreen', 'lg']} loading={loadingSubmit}>
                  <Text modifiers={['blueCrayola', '16x24', '600']} content="Đóng" />
                </Button>
              </div>
              <div className="t-resendSMSQRCode_button-submit" onClick={handleSubmit}>
                <Button modifiers={['ensureBlue', 'lg']} loading={loadingSubmit}>
                  <Text modifiers={['white', '16x24', '600']} content={submitText} />
                </Button>
              </div>
            </div>
          )
        }
        {
          !!status && (
            <div className="t-notifyModal_button-submit" onClick={handleClose}>
              <Button modifiers={['ensureBlue', 'lg']} loading={loadingSubmit}>
                <Text modifiers={['white', '16x24', '600']} content="Đóng" />
              </Button>
            </div>
          )
        }
      </div>
    </CustomModal>
  </div>
);

export default ResendSMSQRCode;
